import styled from "styled-components"
import { Colors } from "../../color/index"
import { Shadows } from "../../shadows/index"

export const CssInput = styled.input`
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	font-size: 14px;

	flex: 1;
	margin-top: 5px;
	padding: 15px 10px;
	border-radius: 8px;
	border: 1px solid ${Colors.black};
	outline: none;

	border: 1px solid #efefef;
	box-shadow: ${Shadows[1]};

	:focus {
		border: 1px solid #c4c4c4;
	}

	::placeholder {
		color: #808c99;
	}
`
